import React, { useEffect, useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";

// Strip HTML from response (optional)
const stripHtml = (html) => {
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

function MetaTags() {
  const [meta, setMeta] = useState({
    title: "mRNA Conference USA 2025 | Innovations in Therapy & Vaccines",
    description: "Join global experts in Boston this October at mRNA Conference USA 2025. Explore vaccine and therapeutics breakthroughs. Register today!",
    ogImage: "",
  });
  let myslug =''
  const [slug, setSlug] = useState("");
  const siteName = "IQ Hub";

  const pageUrl =
    typeof window !== "undefined" ? window.location.href : "";

  useEffect(() => {
    const updateSlug = () => {
      const pathParts = window.location.pathname.split("/").filter(Boolean);
      setSlug(pathParts[pathParts.length - 1] || "");
    };

    updateSlug(); // Set slug initially

    // Patch pushState and replaceState
    const patchHistory = (method) => {
      const original = history[method];
      history[method] = function (...args) {
        const result = original.apply(this, args);
        window.dispatchEvent(new Event("locationchange"));
        return result;
      };
    };

    patchHistory("pushState");
    patchHistory("replaceState");

    // Listen to changes
    window.addEventListener("popstate", updateSlug);
    window.addEventListener("locationchange", updateSlug);

    return () => {
      window.removeEventListener("popstate", updateSlug);
      window.removeEventListener("locationchange", updateSlug);
    };
  }, []);

  console.log(slug,'slug');
  useEffect(() => {

    const fetchMeta = async () => {
      try {
        if(!slug){
            myslug = 'home';
        }else{
            myslug =  slug
                
        }
        console.log(`${process.env.REACT_APP_API_SERVER_URL}/meta-tags/${myslug}`);
        const response = await axios.get(
          `${process.env.REACT_APP_API_SERVER_URL}/meta-tags/${myslug}`
        );
        const { title, description, ogImage } = response.data?.data || {};
        setMeta((prev) => ({
          title: title || prev.title,
          description: description
            ? stripHtml(description)
            : prev.description,
          ogImage: ogImage || prev.ogImage,
        }));
      } catch (error) {
        console.error("Meta fetch failed", error);
      }
    };

    fetchMeta();
  }, [slug]);

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="author" content={siteName} />
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="canonical" href={pageUrl} />

      {/* Open Graph */}
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:image" content={meta.ogImage} />
      <meta property="og:image:secure_url" content={meta.ogImage} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta
        property="og:image:alt"
        content={`Preview image for ${meta.title}`}
      />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:site" content="@IQHub" />
      <meta name="twitter:creator" content="@IQHub" />
      <meta name="twitter:image" content={meta.ogImage} />
    </Helmet>
  );
}

export default MetaTags;
